/** Shopify CDN: Minification failed

Line 34:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 35:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 35:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 37:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 42:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 48:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 23:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 24:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 24:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 26:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 31:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 37:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 37:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 12:1 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 13:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 13:10 Transforming destructuring to the configured target environment ("es5") is not supported yet
Line 15:40 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 20:8 Transforming async functions to the configured target environment ("es5") is not supported yet
Line 26:26 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 26:27 Transforming destructuring to the configured target environment ("es5") is not supported yet

**/
(async () => {
    const { Core } = await importModule('Core');

    customElements.define('cart-total', class extends Core {
        subscriptions = {
            'cart:update': '_cartUpdateHandler'
        }

        async render() {
            await customElements.whenDefined('cart-provider');
            this.publish('cart:add-feature', { feature: 'cart-total' });
            this.subscribe('cart:update', { global: true });
        }

        _cartUpdateHandler({ meta }) {
            this.total = meta.total;
        }

        set total(value) {
            this.textContent = value;
        }
    });
})()